import { styled } from '@material-ui/core';
import { SInput } from '@setvi/shared/components';

export const EnhancedTextAreaInput = styled(SInput)({
  '&.MuiFormControl-root': {
    marginBottom: 0,
    width: '100%'
  },
  '& .MuiInputBase-root': {
    height: 'auto'
  }
});
